import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar, ButtonGroup } from 'react-bootstrap';
import ICurrency from './ICurrency';
import reimburseIcon from '../../assets/images/reimburse.svg';
import ledgerIcon from '../../assets/images/ledger.svg';
import moment from 'moment';

interface IInvoiceHistoryListRowProps {
    invoiceNumber: string;
    invoiceDate: Date;
    dueDate: Date;
    paidDate: Date;
    status: string;
    customer: string;
    sum: number;
    paid: number;
    credited: number;
    creditedPaid: number;
    rest: number;
    type: number;
    key: number;
    showInvoice: (invoiceId: any) => void;
    createPayment: (invoiceId: any) => void;
    creditInvoice: (invoiceId: any) => void;
    viewPayments: (invoiceId: any) => void;
    downloadInvoice: (invoiceId: any) => void;
    canViewPayments: boolean;
    canCreatePayments: boolean;
    canCreditInvoice: boolean;
    invoiceCurrency: ICurrency;
    pastDueDate: number;
    rowClass: string;
}

const InvoiceHistoryListRow = (props: IInvoiceHistoryListRowProps) => {
    return (
        <tr className={props.rowClass}>
            <td>{props.invoiceNumber}</td>
            <td>{moment(props.invoiceDate).format('L')}</td>
            <td>{moment(props.dueDate).format('L')}</td>
            <td>{props.paidDate && moment(props.paidDate).format('L')}</td>
            <td>{props.type === 2 ? Translate('invoice/credit') : Translate(props.status)}</td>
            <td>{props.customer}</td>
            <td>
                {props.invoiceCurrency.prefix}
                {props.sum}
                {props.invoiceCurrency.suffix}
            </td>
            <td>
                {props.invoiceCurrency.prefix}
                {props.paid}
                {props.invoiceCurrency.suffix}
            </td>
            <td>
                {props.invoiceCurrency.prefix}
                {props.credited}
                {props.invoiceCurrency.suffix}
            </td>
            <td>
                {props.invoiceCurrency.prefix}
                {props.creditedPaid}
                {props.invoiceCurrency.suffix}
            </td>
            <td>
                {props.invoiceCurrency.prefix}
                {props.rest}
                {props.invoiceCurrency.suffix}
            </td>
            <td></td>
            <td>
                <ButtonToolbar>
                    <ButtonGroup bsSize="small" className="flex pull-right">
                        <Button bsStyle="default" onClick={props.creditInvoice}>
                            <img
                                className="invoice-toolbar-icons"
                                src={reimburseIcon}
                                title={Translate('invoice-history/list/item/credit-invoice')}
                            ></img>
                        </Button>
                        <Button bsStyle="default" onClick={props.createPayment}>
                            <i
                                className="material-icons md-18"
                                title={Translate('invoice-history/list/item/create-payment')}
                            >
                                payment
                            </i>
                        </Button>
                        <Button bsStyle="default" onClick={props.viewPayments}>
                            <img
                                className="invoice-toolbar-icons"
                                src={ledgerIcon}
                                title={Translate('invoice-history/list/item/view-payments')}
                            ></img>
                        </Button>
                        <Button bsStyle="default" onClick={props.showInvoice}>
                            <i
                                className="material-icons md-18"
                                title={Translate('invoice-history/list/item/show-invoice')}
                            >
                                visibility
                            </i>
                        </Button>
                        <Button bsStyle="default" onClick={props.downloadInvoice}>
                            <i className="material-icons md-18">picture_as_pdf</i>
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default InvoiceHistoryListRow;
